module.exports = __webpack_public_path__ + "2a634a94d5b175c41a71fac233a52f53.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/images/patterns/header-profile.png
// module id = 223
// module chunks = 1